/**
 * HOW A FACE IS DRAWN, one look for each of its three states, on an invoice's "How did we do?" and
 * on Feedback alike (round six, slice S3), so a face reads the same wherever it is tapped:
 *
 * - FREE, neither chosen nor sent: the artboard's open circle.
 * - CHOSEN, tapped and waiting for Send (round four, slice F1, on an invoice; on Feedback since round
 *   six, slice S3): a navy ring around a navy edge on the pale navy a chosen area is drawn on, and
 *   never the fill, so a face waiting for Send does not read as an answer the office has. The ring,
 *   its shape and not its colour, sets it apart from a face not chosen, and the semibold name under
 *   it as on any face lit, and `INVOICE_FEEDBACK.notSent` describes it to a screen reader. The
 *   replay of the owner's household on 2026-10-18 found Feedback drawing a face tapped on Home in
 *   the navy fill, which on Home means sent, so she could leave thinking it had gone.
 * - SENT, or the one ops says counts: the artboard's navy fill, as Home draws an answer that stands.
 */
export const FACE_FREE =
  'border-border-strong bg-surface-raised text-text-brand hover:bg-surface-accent-soft';

export const FACE_CHOSEN =
  'border-surface-brand bg-surface-brand-soft text-text-brand ring-2 ring-surface-brand ring-offset-2 ring-offset-surface-page';

export const FACE_SENT = 'border-surface-brand bg-surface-brand text-text-on-brand';
